<p class="font-bold line-height-2" i18n>You have selected "eCall Only support".</p>

<p class="font-bold line-height-2" i18n>Please enter the numbers of "Test Number" & "Reconfiguration Number".</p>

<div class="mx-6">
  <div style="width: 750px">
    <p-table
      [value]="profileValues.regulatoryECallSupport.eCallOnlyRecords"
      dataKey="recordNumber"
      styleClass="p-datatable-striped p-datatable-gridlines"
      showGridlines="true"
      stripedRows="true"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 7rem" />
          <col />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Record #</th>
          <th i18n>Name</th>
          <th>
            <div i18n>Dialing Number</div>
            <div class="font-medium" i18n>(e.g., +13015558190)</div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-eCallRecord>
        <tr>
          <td style="text-align: center">{{ eCallRecord.recordNumber }}</td>
          <td>
            <input
              class="maximize-inputs"
              type="text"
              pInputText
              [(ngModel)]="eCallRecord.displayName"
              (input)="handleFormEvents()"
              maxlength="25"
            />
          </td>
          <td>
            <input
              class="maximize-inputs"
              type="text"
              pInputText
              [(ngModel)]="eCallRecord.dialingNumber"
              (input)="handleFormEvents()"
              maxlength="20"
              rsPhoneNumberInput
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" i18n>No records defined.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
